export const MAKE_LIST = [
	{ value: '215', label: 'Abarth' },
	{ value: '42', label: 'Airman' },
	{ value: '96', label: 'Alfa Romeo' },
	{ value: '270', label: 'Alfaromeo' },
	{ value: '273', label: 'Alpina' },
	{ value: '288', label: 'America Others' },
	{ value: '214', label: 'Amg' },
	{ value: '251', label: 'Any' },
	{ value: '97', label: 'Aston Martin' },
	{ value: '248', label: 'Auction' },
	{ value: '283', label: 'Auction Deposit' },
	{ value: '49', label: 'Audi' },
	{ value: '106', label: 'Austin' },
	{ value: '234', label: 'Autobianchi' },
	{ value: '291', label: 'Balance' },
	{ value: '289', label: 'Balance & amp; Auction Deposit' },
	{ value: '292', label: 'Balance Invoice' },
	{ value: '285', label: 'Balance Of Cars' },
	{ value: '121', label: 'Barford' },
	{ value: '79', label: 'Bentley' },
	{ value: '50', label: 'Bmw' },
	{ value: '216', label: 'Bmw Alpina' },
	{ value: '150', label: 'Bobcat' },
	{ value: '107', label: 'Bomag' },
	{ value: '286', label: 'Brabus' },
	{ value: '103', label: 'Bristol' },
	{ value: '80', label: 'Buick' },
	{ value: '158', label: 'Cadillac' },
	{ value: '254', label: 'Cancellation' },
	{ value: '263', label: 'Car' },
	{ value: '139', label: 'Cat' },
	{ value: '241', label: 'Caterpillar' },
	{ value: '92', label: 'Chevrolet' },
	{ value: '91', label: 'Chrysler' },
	{ value: '229', label: 'Chrysler Jeep' },
	{ value: '98', label: 'Citroen' },
	{ value: '265', label: 'Color Print' },
	{ value: '238', label: 'Ct & amp; t' },
	{ value: '69', label: 'Daewoo' },
	{ value: '123', label: 'Daf' },
	{ value: '68', label: 'Daihatsu' },
	{ value: '222', label: 'Daimler' },
	{ value: '70', label: 'Denyo' },
	{ value: '290', label: 'Deposit' },
	{ value: '71', label: 'Dhi' },
	{ value: '231', label: 'Dodge' },
	{ value: '134', label: 'Dongfeng' },
	{ value: '268', label: 'Door' },
	{ value: '212', label: 'Ducati' },
	{ value: '269', label: 'Engine' },
	{ value: '272', label: 'England Others' },
	{ value: '224', label: 'Eunos' },
	{ value: '219', label: 'Europe Ford' },
	{ value: '104', label: 'Ferrari' },
	{ value: '157', label: 'Fiat' },
	{ value: '141', label: 'Foden' },
	{ value: '82', label: 'Ford' },
	{ value: '221', label: 'Ford Japan' },
	{ value: '246', label: 'Freelance' },
	{ value: '136', label: 'Geely' },
	{ value: '243', label: 'Giga' },
	{ value: '128', label: 'Gm Daewoo' },
	{ value: '81', label: 'Gmc' },
	{ value: '84', label: 'Hammer' },
	{ value: '284', label: 'Harrier Balance' },
	{ value: '281', label: 'Hiaces Balance' },
	{ value: '52', label: 'Hino' },
	{ value: '53', label: 'Hitachi' },
	{ value: '159', label: 'Hokuetsu' },
	{ value: '39', label: 'Honda' },
	{ value: '267', label: 'Howo' },
	{ value: '232', label: 'Hummer' },
	{ value: '83', label: 'Hyundai' },
	{ value: '67', label: 'Ihi' },
	{ value: '277', label: 'Infinity' },
	{ value: '40', label: 'Isuzu' },
	{ value: '54', label: 'Jaguar' },
	{ value: '130', label: 'Jcb' },
	{ value: '138', label: 'Jeep' },
	{ value: '146', label: 'Jemini' },
	{ value: '116', label: 'Kato' },
	{ value: '90', label: 'Kawasaki' },
	{ value: '89', label: 'Kia' },
	{ value: '48', label: 'Kobelco' },
	{ value: '47', label: 'Komatsu' },
	{ value: '111', label: 'Kubota' },
	{ value: '217', label: 'Lamborghini' },
	{ value: '235', label: 'Lancia' },
	{ value: '73', label: 'Land Rover' },
	{ value: '55', label: 'Lexus' },
	{ value: '233', label: 'Lincoln' },
	{ value: '85', label: 'Lotus' },
	{ value: '109', label: 'Maserati' },
	{ value: '108', label: 'Massey Ferguson' },
	{ value: '228', label: 'Maybach' },
	{ value: '41', label: 'Mazda' },
	{ value: '274', label: 'Mcc' },
	{ value: '242', label: 'Meigi' },
	{ value: '245', label: 'Meiwa' },
	{ value: '211', label: 'Mercedes Benz' },
	{ value: '236', label: 'Mercury' },
	{ value: '227', label: 'Mg' },
	{ value: '86', label: 'Mini' },
	{ value: '260', label: 'Mira' },
	{ value: '37', label: 'Mitsubishi' },
	{ value: '271', label: 'Mitsubishi Fusou' },
	{ value: '218', label: 'Mitsuoka' },
	{ value: '287', label: 'Moke' },
	{ value: '279', label: 'Mybach' },
	{ value: '122', label: 'Neoplan' },
	{ value: '259', label: 'New' },
	{ value: '257', label: 'Nichiyu' },
	{ value: '38', label: 'Nissan' },
	{ value: '43', label: 'Nissan Diesel' },
	{ value: '252', label: 'Nissan Diesel (ud)' },
	{ value: '253', label: 'Nissan Mt' },
	{ value: '255', label: 'Nummi' },
	{ value: '75', label: 'Opel' },
	{ value: '213', label: 'Other' },
	{ value: '275', label: 'Others' },
	{ value: '250', label: 'Partial' },
	{ value: '244', label: 'Pending Toyota' },
	{ value: '76', label: 'Peugeot' },
	{ value: '237', label: 'Pontiac' },
	{ value: '100', label: 'Porsche' },
	{ value: '95', label: 'Proton' },
	{ value: '261', label: 'Range Rover' },
	{ value: '247', label: 'Refund' },
	{ value: '126', label: 'Renault' },
	{ value: '78', label: 'Rolls Royce' },
	{ value: '276', label: 'Rolls-royce' },
	{ value: '220', label: 'Rollsroyce' },
	{ value: '225', label: 'Rover' },
	{ value: '230', label: 'Saab' },
	{ value: '101', label: 'Sakai' },
	{ value: '223', label: 'Saturn' },
	{ value: '280', label: 'Scania' },
	{ value: '266', label: 'Scrap' },
	{ value: '256', label: 'Select' },
	{ value: '226', label: 'Smart' },
	{ value: '127', label: 'Ssang Yong' },
	{ value: '46', label: 'Subaru' },
	{ value: '58', label: 'Sumitomo' },
	{ value: '45', label: 'Suzuki' },
	{ value: '59', label: 'Tadano' },
	{ value: '60', label: 'Tata' },
	{ value: '61', label: 'Tcm' },
	{ value: '278', label: 'Tesla' },
	{ value: '264', label: 'Test' },
	{ value: '36', label: 'Toyota' },
	{ value: '62', label: 'Unic' },
	{ value: '282', label: 'Used' },
	{ value: '64', label: 'Volkswagen' },
	{ value: '63', label: 'Volvo' },
	{ value: '65', label: 'Yamaha' },
	{ value: '66', label: 'Yanmar' }
]